import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedModule } from "src/app/shared/shared.module";
import { TdspConversionPixelRoutingModule } from "./tdsp-conversion-pixel-routing.module";

import { TdspCreateConversionPixelComponent } from "./tdsp-create-conversion-pixel/tdsp-create-conversion-pixel.component";
import { TdspEditConversionPixelComponent } from "./tdsp-edit-conversion-pixel/tdsp-edit-conversion-pixel.component";
import { TdspConversionPixelLandingComponent } from "./tdsp-conversion-pixel-landing/tdsp-conversion-pixel-landing.component";
import { TdspConversionPixelBasicComponent } from "./steps/tdsp-conversion-pixel-basic/tdsp-conversion-pixel-basic.component";

@NgModule({
  declarations: [
    TdspCreateConversionPixelComponent,
    TdspEditConversionPixelComponent,
    TdspConversionPixelLandingComponent,
    TdspConversionPixelBasicComponent,
  ],
  imports: [CommonModule, SharedModule, TdspConversionPixelRoutingModule],
})
export class TdspConversionPixelModule {}
